/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedMissionRouteImport } from './routes/_authenticated/mission'
import { Route as AuthenticatedFilesRouteImport } from './routes/_authenticated/files'
import { Route as AuthenticatedBoardsRouteImport } from './routes/_authenticated/boards'
import { Route as AuthenticatedUniversityIndexRouteImport } from './routes/_authenticated/university/index'
import { Route as AuthenticatedStrategyIndexRouteImport } from './routes/_authenticated/strategy/index'
import { Route as AuthenticatedPrinciplesIndexRouteImport } from './routes/_authenticated/principles/index'
import { Route as AuthenticatedGoalsIndexRouteImport } from './routes/_authenticated/goals/index'
import { Route as AuthenticatedDepartmentsIndexRouteImport } from './routes/_authenticated/departments/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedConstitutionIndexRouteImport } from './routes/_authenticated/constitution/index'
import { Route as AuthenticatedArchitectIndexRouteImport } from './routes/_authenticated/architect/index'
import { Route as AuthenticatedUniversityPatternsRouteImport } from './routes/_authenticated/university/patterns'
import { Route as AuthenticatedSettingsWorkspaceRouteImport } from './routes/_authenticated/settings/workspace'
import { Route as AuthenticatedSettingsTelegramRouteImport } from './routes/_authenticated/settings/telegram'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsMembersRouteImport } from './routes/_authenticated/settings/members'
import { Route as AuthenticatedProjectProjectIdRouteImport } from './routes/_authenticated/project/$projectId'
import { Route as AuthenticatedGoalsGoalIdRouteImport } from './routes/_authenticated/goals/$goalId'
import { Route as AuthenticatedFilesSplatRouteImport } from './routes/_authenticated/files/$'
import { Route as AuthenticatedDepartmentsDeptKeyRouteImport } from './routes/_authenticated/departments/$deptKey'
import { Route as AuthenticatedConstitutionProposalsRouteImport } from './routes/_authenticated/constitution/proposals'
import { Route as AuthenticatedConstitutionEditRouteImport } from './routes/_authenticated/constitution/edit'
import { Route as AuthenticatedBoardBoardIdRouteImport } from './routes/_authenticated/board/$boardId'
import { Route as AuthenticatedArchitectDispatchRouteImport } from './routes/_authenticated/architect/dispatch'
import { Route as AuthenticatedUniversityTunersIndexRouteImport } from './routes/_authenticated/university/tuners/index'
import { Route as AuthenticatedUniversityTrainingIndexRouteImport } from './routes/_authenticated/university/training/index'
import { Route as AuthenticatedUniversitySkillsIndexRouteImport } from './routes/_authenticated/university/skills/index'
import { Route as AuthenticatedUniversityMarketplaceIndexRouteImport } from './routes/_authenticated/university/marketplace/index'
import { Route as AuthenticatedUniversityAbTestsIndexRouteImport } from './routes/_authenticated/university/ab-tests/index'
import { Route as AuthenticatedUniversityTunersTunerIdRouteImport } from './routes/_authenticated/university/tuners/$tunerId'
import { Route as AuthenticatedUniversityTrainingSessionIdRouteImport } from './routes/_authenticated/university/training/$sessionId'
import { Route as AuthenticatedUniversitySkillsSkillIdRouteImport } from './routes/_authenticated/university/skills/$skillId'
import { Route as AuthenticatedUniversityMarketplaceSkillIdRouteImport } from './routes/_authenticated/university/marketplace/$skillId'
import { Route as AuthenticatedUniversityAbTestsNewRouteImport } from './routes/_authenticated/university/ab-tests/new'
import { Route as AuthenticatedUniversityAbTestsTestIdRouteImport } from './routes/_authenticated/university/ab-tests/$testId'
import { Route as AuthenticatedArchitectRunRunIdRouteImport } from './routes/_authenticated/architect/run/$runId'
import { Route as AuthenticatedBoardBoardIdCardCardIdRouteImport } from './routes/_authenticated/board/$boardId/card/$cardId'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedMissionRoute = AuthenticatedMissionRouteImport.update({
  id: '/mission',
  path: '/mission',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFilesRoute = AuthenticatedFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBoardsRoute = AuthenticatedBoardsRouteImport.update({
  id: '/boards',
  path: '/boards',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUniversityIndexRoute =
  AuthenticatedUniversityIndexRouteImport.update({
    id: '/university/',
    path: '/university/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStrategyIndexRoute =
  AuthenticatedStrategyIndexRouteImport.update({
    id: '/strategy/',
    path: '/strategy/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPrinciplesIndexRoute =
  AuthenticatedPrinciplesIndexRouteImport.update({
    id: '/principles/',
    path: '/principles/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoalsIndexRoute = AuthenticatedGoalsIndexRouteImport.update({
  id: '/goals/',
  path: '/goals/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDepartmentsIndexRoute =
  AuthenticatedDepartmentsIndexRouteImport.update({
    id: '/departments/',
    path: '/departments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConstitutionIndexRoute =
  AuthenticatedConstitutionIndexRouteImport.update({
    id: '/constitution/',
    path: '/constitution/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArchitectIndexRoute =
  AuthenticatedArchitectIndexRouteImport.update({
    id: '/architect/',
    path: '/architect/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityPatternsRoute =
  AuthenticatedUniversityPatternsRouteImport.update({
    id: '/university/patterns',
    path: '/university/patterns',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsWorkspaceRoute =
  AuthenticatedSettingsWorkspaceRouteImport.update({
    id: '/settings/workspace',
    path: '/settings/workspace',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsTelegramRoute =
  AuthenticatedSettingsTelegramRouteImport.update({
    id: '/settings/telegram',
    path: '/settings/telegram',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsMembersRoute =
  AuthenticatedSettingsMembersRouteImport.update({
    id: '/settings/members',
    path: '/settings/members',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectProjectIdRoute =
  AuthenticatedProjectProjectIdRouteImport.update({
    id: '/project/$projectId',
    path: '/project/$projectId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoalsGoalIdRoute =
  AuthenticatedGoalsGoalIdRouteImport.update({
    id: '/goals/$goalId',
    path: '/goals/$goalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFilesSplatRoute = AuthenticatedFilesSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedFilesRoute,
} as any)
const AuthenticatedDepartmentsDeptKeyRoute =
  AuthenticatedDepartmentsDeptKeyRouteImport.update({
    id: '/departments/$deptKey',
    path: '/departments/$deptKey',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConstitutionProposalsRoute =
  AuthenticatedConstitutionProposalsRouteImport.update({
    id: '/constitution/proposals',
    path: '/constitution/proposals',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConstitutionEditRoute =
  AuthenticatedConstitutionEditRouteImport.update({
    id: '/constitution/edit',
    path: '/constitution/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBoardBoardIdRoute =
  AuthenticatedBoardBoardIdRouteImport.update({
    id: '/board/$boardId',
    path: '/board/$boardId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArchitectDispatchRoute =
  AuthenticatedArchitectDispatchRouteImport.update({
    id: '/architect/dispatch',
    path: '/architect/dispatch',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityTunersIndexRoute =
  AuthenticatedUniversityTunersIndexRouteImport.update({
    id: '/university/tuners/',
    path: '/university/tuners/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityTrainingIndexRoute =
  AuthenticatedUniversityTrainingIndexRouteImport.update({
    id: '/university/training/',
    path: '/university/training/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversitySkillsIndexRoute =
  AuthenticatedUniversitySkillsIndexRouteImport.update({
    id: '/university/skills/',
    path: '/university/skills/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityMarketplaceIndexRoute =
  AuthenticatedUniversityMarketplaceIndexRouteImport.update({
    id: '/university/marketplace/',
    path: '/university/marketplace/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityAbTestsIndexRoute =
  AuthenticatedUniversityAbTestsIndexRouteImport.update({
    id: '/university/ab-tests/',
    path: '/university/ab-tests/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityTunersTunerIdRoute =
  AuthenticatedUniversityTunersTunerIdRouteImport.update({
    id: '/university/tuners/$tunerId',
    path: '/university/tuners/$tunerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityTrainingSessionIdRoute =
  AuthenticatedUniversityTrainingSessionIdRouteImport.update({
    id: '/university/training/$sessionId',
    path: '/university/training/$sessionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversitySkillsSkillIdRoute =
  AuthenticatedUniversitySkillsSkillIdRouteImport.update({
    id: '/university/skills/$skillId',
    path: '/university/skills/$skillId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityMarketplaceSkillIdRoute =
  AuthenticatedUniversityMarketplaceSkillIdRouteImport.update({
    id: '/university/marketplace/$skillId',
    path: '/university/marketplace/$skillId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityAbTestsNewRoute =
  AuthenticatedUniversityAbTestsNewRouteImport.update({
    id: '/university/ab-tests/new',
    path: '/university/ab-tests/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUniversityAbTestsTestIdRoute =
  AuthenticatedUniversityAbTestsTestIdRouteImport.update({
    id: '/university/ab-tests/$testId',
    path: '/university/ab-tests/$testId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedArchitectRunRunIdRoute =
  AuthenticatedArchitectRunRunIdRouteImport.update({
    id: '/architect/run/$runId',
    path: '/architect/run/$runId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBoardBoardIdCardCardIdRoute =
  AuthenticatedBoardBoardIdCardCardIdRouteImport.update({
    id: '/card/$cardId',
    path: '/card/$cardId',
    getParentRoute: () => AuthenticatedBoardBoardIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/boards': typeof AuthenticatedBoardsRoute
  '/files': typeof AuthenticatedFilesRouteWithChildren
  '/mission': typeof AuthenticatedMissionRoute
  '/architect/dispatch': typeof AuthenticatedArchitectDispatchRoute
  '/board/$boardId': typeof AuthenticatedBoardBoardIdRouteWithChildren
  '/constitution/edit': typeof AuthenticatedConstitutionEditRoute
  '/constitution/proposals': typeof AuthenticatedConstitutionProposalsRoute
  '/departments/$deptKey': typeof AuthenticatedDepartmentsDeptKeyRoute
  '/files/$': typeof AuthenticatedFilesSplatRoute
  '/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/project/$projectId': typeof AuthenticatedProjectProjectIdRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/telegram': typeof AuthenticatedSettingsTelegramRoute
  '/settings/workspace': typeof AuthenticatedSettingsWorkspaceRoute
  '/university/patterns': typeof AuthenticatedUniversityPatternsRoute
  '/architect/': typeof AuthenticatedArchitectIndexRoute
  '/constitution/': typeof AuthenticatedConstitutionIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/departments/': typeof AuthenticatedDepartmentsIndexRoute
  '/goals/': typeof AuthenticatedGoalsIndexRoute
  '/principles/': typeof AuthenticatedPrinciplesIndexRoute
  '/strategy/': typeof AuthenticatedStrategyIndexRoute
  '/university/': typeof AuthenticatedUniversityIndexRoute
  '/architect/run/$runId': typeof AuthenticatedArchitectRunRunIdRoute
  '/university/ab-tests/$testId': typeof AuthenticatedUniversityAbTestsTestIdRoute
  '/university/ab-tests/new': typeof AuthenticatedUniversityAbTestsNewRoute
  '/university/marketplace/$skillId': typeof AuthenticatedUniversityMarketplaceSkillIdRoute
  '/university/skills/$skillId': typeof AuthenticatedUniversitySkillsSkillIdRoute
  '/university/training/$sessionId': typeof AuthenticatedUniversityTrainingSessionIdRoute
  '/university/tuners/$tunerId': typeof AuthenticatedUniversityTunersTunerIdRoute
  '/university/ab-tests/': typeof AuthenticatedUniversityAbTestsIndexRoute
  '/university/marketplace/': typeof AuthenticatedUniversityMarketplaceIndexRoute
  '/university/skills/': typeof AuthenticatedUniversitySkillsIndexRoute
  '/university/training/': typeof AuthenticatedUniversityTrainingIndexRoute
  '/university/tuners/': typeof AuthenticatedUniversityTunersIndexRoute
  '/board/$boardId/card/$cardId': typeof AuthenticatedBoardBoardIdCardCardIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/boards': typeof AuthenticatedBoardsRoute
  '/files': typeof AuthenticatedFilesRouteWithChildren
  '/mission': typeof AuthenticatedMissionRoute
  '/architect/dispatch': typeof AuthenticatedArchitectDispatchRoute
  '/board/$boardId': typeof AuthenticatedBoardBoardIdRouteWithChildren
  '/constitution/edit': typeof AuthenticatedConstitutionEditRoute
  '/constitution/proposals': typeof AuthenticatedConstitutionProposalsRoute
  '/departments/$deptKey': typeof AuthenticatedDepartmentsDeptKeyRoute
  '/files/$': typeof AuthenticatedFilesSplatRoute
  '/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/project/$projectId': typeof AuthenticatedProjectProjectIdRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/telegram': typeof AuthenticatedSettingsTelegramRoute
  '/settings/workspace': typeof AuthenticatedSettingsWorkspaceRoute
  '/university/patterns': typeof AuthenticatedUniversityPatternsRoute
  '/architect': typeof AuthenticatedArchitectIndexRoute
  '/constitution': typeof AuthenticatedConstitutionIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/departments': typeof AuthenticatedDepartmentsIndexRoute
  '/goals': typeof AuthenticatedGoalsIndexRoute
  '/principles': typeof AuthenticatedPrinciplesIndexRoute
  '/strategy': typeof AuthenticatedStrategyIndexRoute
  '/university': typeof AuthenticatedUniversityIndexRoute
  '/architect/run/$runId': typeof AuthenticatedArchitectRunRunIdRoute
  '/university/ab-tests/$testId': typeof AuthenticatedUniversityAbTestsTestIdRoute
  '/university/ab-tests/new': typeof AuthenticatedUniversityAbTestsNewRoute
  '/university/marketplace/$skillId': typeof AuthenticatedUniversityMarketplaceSkillIdRoute
  '/university/skills/$skillId': typeof AuthenticatedUniversitySkillsSkillIdRoute
  '/university/training/$sessionId': typeof AuthenticatedUniversityTrainingSessionIdRoute
  '/university/tuners/$tunerId': typeof AuthenticatedUniversityTunersTunerIdRoute
  '/university/ab-tests': typeof AuthenticatedUniversityAbTestsIndexRoute
  '/university/marketplace': typeof AuthenticatedUniversityMarketplaceIndexRoute
  '/university/skills': typeof AuthenticatedUniversitySkillsIndexRoute
  '/university/training': typeof AuthenticatedUniversityTrainingIndexRoute
  '/university/tuners': typeof AuthenticatedUniversityTunersIndexRoute
  '/board/$boardId/card/$cardId': typeof AuthenticatedBoardBoardIdCardCardIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/_authenticated/boards': typeof AuthenticatedBoardsRoute
  '/_authenticated/files': typeof AuthenticatedFilesRouteWithChildren
  '/_authenticated/mission': typeof AuthenticatedMissionRoute
  '/_authenticated/architect/dispatch': typeof AuthenticatedArchitectDispatchRoute
  '/_authenticated/board/$boardId': typeof AuthenticatedBoardBoardIdRouteWithChildren
  '/_authenticated/constitution/edit': typeof AuthenticatedConstitutionEditRoute
  '/_authenticated/constitution/proposals': typeof AuthenticatedConstitutionProposalsRoute
  '/_authenticated/departments/$deptKey': typeof AuthenticatedDepartmentsDeptKeyRoute
  '/_authenticated/files/$': typeof AuthenticatedFilesSplatRoute
  '/_authenticated/goals/$goalId': typeof AuthenticatedGoalsGoalIdRoute
  '/_authenticated/project/$projectId': typeof AuthenticatedProjectProjectIdRoute
  '/_authenticated/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/telegram': typeof AuthenticatedSettingsTelegramRoute
  '/_authenticated/settings/workspace': typeof AuthenticatedSettingsWorkspaceRoute
  '/_authenticated/university/patterns': typeof AuthenticatedUniversityPatternsRoute
  '/_authenticated/architect/': typeof AuthenticatedArchitectIndexRoute
  '/_authenticated/constitution/': typeof AuthenticatedConstitutionIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/departments/': typeof AuthenticatedDepartmentsIndexRoute
  '/_authenticated/goals/': typeof AuthenticatedGoalsIndexRoute
  '/_authenticated/principles/': typeof AuthenticatedPrinciplesIndexRoute
  '/_authenticated/strategy/': typeof AuthenticatedStrategyIndexRoute
  '/_authenticated/university/': typeof AuthenticatedUniversityIndexRoute
  '/_authenticated/architect/run/$runId': typeof AuthenticatedArchitectRunRunIdRoute
  '/_authenticated/university/ab-tests/$testId': typeof AuthenticatedUniversityAbTestsTestIdRoute
  '/_authenticated/university/ab-tests/new': typeof AuthenticatedUniversityAbTestsNewRoute
  '/_authenticated/university/marketplace/$skillId': typeof AuthenticatedUniversityMarketplaceSkillIdRoute
  '/_authenticated/university/skills/$skillId': typeof AuthenticatedUniversitySkillsSkillIdRoute
  '/_authenticated/university/training/$sessionId': typeof AuthenticatedUniversityTrainingSessionIdRoute
  '/_authenticated/university/tuners/$tunerId': typeof AuthenticatedUniversityTunersTunerIdRoute
  '/_authenticated/university/ab-tests/': typeof AuthenticatedUniversityAbTestsIndexRoute
  '/_authenticated/university/marketplace/': typeof AuthenticatedUniversityMarketplaceIndexRoute
  '/_authenticated/university/skills/': typeof AuthenticatedUniversitySkillsIndexRoute
  '/_authenticated/university/training/': typeof AuthenticatedUniversityTrainingIndexRoute
  '/_authenticated/university/tuners/': typeof AuthenticatedUniversityTunersIndexRoute
  '/_authenticated/board/$boardId/card/$cardId': typeof AuthenticatedBoardBoardIdCardCardIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/boards'
    | '/files'
    | '/mission'
    | '/architect/dispatch'
    | '/board/$boardId'
    | '/constitution/edit'
    | '/constitution/proposals'
    | '/departments/$deptKey'
    | '/files/$'
    | '/goals/$goalId'
    | '/project/$projectId'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/telegram'
    | '/settings/workspace'
    | '/university/patterns'
    | '/architect/'
    | '/constitution/'
    | '/dashboard/'
    | '/departments/'
    | '/goals/'
    | '/principles/'
    | '/strategy/'
    | '/university/'
    | '/architect/run/$runId'
    | '/university/ab-tests/$testId'
    | '/university/ab-tests/new'
    | '/university/marketplace/$skillId'
    | '/university/skills/$skillId'
    | '/university/training/$sessionId'
    | '/university/tuners/$tunerId'
    | '/university/ab-tests/'
    | '/university/marketplace/'
    | '/university/skills/'
    | '/university/training/'
    | '/university/tuners/'
    | '/board/$boardId/card/$cardId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/boards'
    | '/files'
    | '/mission'
    | '/architect/dispatch'
    | '/board/$boardId'
    | '/constitution/edit'
    | '/constitution/proposals'
    | '/departments/$deptKey'
    | '/files/$'
    | '/goals/$goalId'
    | '/project/$projectId'
    | '/settings/members'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/telegram'
    | '/settings/workspace'
    | '/university/patterns'
    | '/architect'
    | '/constitution'
    | '/dashboard'
    | '/departments'
    | '/goals'
    | '/principles'
    | '/strategy'
    | '/university'
    | '/architect/run/$runId'
    | '/university/ab-tests/$testId'
    | '/university/ab-tests/new'
    | '/university/marketplace/$skillId'
    | '/university/skills/$skillId'
    | '/university/training/$sessionId'
    | '/university/tuners/$tunerId'
    | '/university/ab-tests'
    | '/university/marketplace'
    | '/university/skills'
    | '/university/training'
    | '/university/tuners'
    | '/board/$boardId/card/$cardId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/signup'
    | '/_authenticated/boards'
    | '/_authenticated/files'
    | '/_authenticated/mission'
    | '/_authenticated/architect/dispatch'
    | '/_authenticated/board/$boardId'
    | '/_authenticated/constitution/edit'
    | '/_authenticated/constitution/proposals'
    | '/_authenticated/departments/$deptKey'
    | '/_authenticated/files/$'
    | '/_authenticated/goals/$goalId'
    | '/_authenticated/project/$projectId'
    | '/_authenticated/settings/members'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/telegram'
    | '/_authenticated/settings/workspace'
    | '/_authenticated/university/patterns'
    | '/_authenticated/architect/'
    | '/_authenticated/constitution/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/departments/'
    | '/_authenticated/goals/'
    | '/_authenticated/principles/'
    | '/_authenticated/strategy/'
    | '/_authenticated/university/'
    | '/_authenticated/architect/run/$runId'
    | '/_authenticated/university/ab-tests/$testId'
    | '/_authenticated/university/ab-tests/new'
    | '/_authenticated/university/marketplace/$skillId'
    | '/_authenticated/university/skills/$skillId'
    | '/_authenticated/university/training/$sessionId'
    | '/_authenticated/university/tuners/$tunerId'
    | '/_authenticated/university/ab-tests/'
    | '/_authenticated/university/marketplace/'
    | '/_authenticated/university/skills/'
    | '/_authenticated/university/training/'
    | '/_authenticated/university/tuners/'
    | '/_authenticated/board/$boardId/card/$cardId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/mission': {
      id: '/_authenticated/mission'
      path: '/mission'
      fullPath: '/mission'
      preLoaderRoute: typeof AuthenticatedMissionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files': {
      id: '/_authenticated/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AuthenticatedFilesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/boards': {
      id: '/_authenticated/boards'
      path: '/boards'
      fullPath: '/boards'
      preLoaderRoute: typeof AuthenticatedBoardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/': {
      id: '/_authenticated/university/'
      path: '/university'
      fullPath: '/university/'
      preLoaderRoute: typeof AuthenticatedUniversityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/strategy/': {
      id: '/_authenticated/strategy/'
      path: '/strategy'
      fullPath: '/strategy/'
      preLoaderRoute: typeof AuthenticatedStrategyIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/principles/': {
      id: '/_authenticated/principles/'
      path: '/principles'
      fullPath: '/principles/'
      preLoaderRoute: typeof AuthenticatedPrinciplesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/': {
      id: '/_authenticated/goals/'
      path: '/goals'
      fullPath: '/goals/'
      preLoaderRoute: typeof AuthenticatedGoalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/departments/': {
      id: '/_authenticated/departments/'
      path: '/departments'
      fullPath: '/departments/'
      preLoaderRoute: typeof AuthenticatedDepartmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/constitution/': {
      id: '/_authenticated/constitution/'
      path: '/constitution'
      fullPath: '/constitution/'
      preLoaderRoute: typeof AuthenticatedConstitutionIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/architect/': {
      id: '/_authenticated/architect/'
      path: '/architect'
      fullPath: '/architect/'
      preLoaderRoute: typeof AuthenticatedArchitectIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/patterns': {
      id: '/_authenticated/university/patterns'
      path: '/university/patterns'
      fullPath: '/university/patterns'
      preLoaderRoute: typeof AuthenticatedUniversityPatternsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/workspace': {
      id: '/_authenticated/settings/workspace'
      path: '/settings/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AuthenticatedSettingsWorkspaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/telegram': {
      id: '/_authenticated/settings/telegram'
      path: '/settings/telegram'
      fullPath: '/settings/telegram'
      preLoaderRoute: typeof AuthenticatedSettingsTelegramRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/members': {
      id: '/_authenticated/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/project/$projectId': {
      id: '/_authenticated/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectProjectIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/$goalId': {
      id: '/_authenticated/goals/$goalId'
      path: '/goals/$goalId'
      fullPath: '/goals/$goalId'
      preLoaderRoute: typeof AuthenticatedGoalsGoalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files/$': {
      id: '/_authenticated/files/$'
      path: '/$'
      fullPath: '/files/$'
      preLoaderRoute: typeof AuthenticatedFilesSplatRouteImport
      parentRoute: typeof AuthenticatedFilesRoute
    }
    '/_authenticated/departments/$deptKey': {
      id: '/_authenticated/departments/$deptKey'
      path: '/departments/$deptKey'
      fullPath: '/departments/$deptKey'
      preLoaderRoute: typeof AuthenticatedDepartmentsDeptKeyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/constitution/proposals': {
      id: '/_authenticated/constitution/proposals'
      path: '/constitution/proposals'
      fullPath: '/constitution/proposals'
      preLoaderRoute: typeof AuthenticatedConstitutionProposalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/constitution/edit': {
      id: '/_authenticated/constitution/edit'
      path: '/constitution/edit'
      fullPath: '/constitution/edit'
      preLoaderRoute: typeof AuthenticatedConstitutionEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/board/$boardId': {
      id: '/_authenticated/board/$boardId'
      path: '/board/$boardId'
      fullPath: '/board/$boardId'
      preLoaderRoute: typeof AuthenticatedBoardBoardIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/architect/dispatch': {
      id: '/_authenticated/architect/dispatch'
      path: '/architect/dispatch'
      fullPath: '/architect/dispatch'
      preLoaderRoute: typeof AuthenticatedArchitectDispatchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/tuners/': {
      id: '/_authenticated/university/tuners/'
      path: '/university/tuners'
      fullPath: '/university/tuners/'
      preLoaderRoute: typeof AuthenticatedUniversityTunersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/training/': {
      id: '/_authenticated/university/training/'
      path: '/university/training'
      fullPath: '/university/training/'
      preLoaderRoute: typeof AuthenticatedUniversityTrainingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/skills/': {
      id: '/_authenticated/university/skills/'
      path: '/university/skills'
      fullPath: '/university/skills/'
      preLoaderRoute: typeof AuthenticatedUniversitySkillsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/marketplace/': {
      id: '/_authenticated/university/marketplace/'
      path: '/university/marketplace'
      fullPath: '/university/marketplace/'
      preLoaderRoute: typeof AuthenticatedUniversityMarketplaceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/ab-tests/': {
      id: '/_authenticated/university/ab-tests/'
      path: '/university/ab-tests'
      fullPath: '/university/ab-tests/'
      preLoaderRoute: typeof AuthenticatedUniversityAbTestsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/tuners/$tunerId': {
      id: '/_authenticated/university/tuners/$tunerId'
      path: '/university/tuners/$tunerId'
      fullPath: '/university/tuners/$tunerId'
      preLoaderRoute: typeof AuthenticatedUniversityTunersTunerIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/training/$sessionId': {
      id: '/_authenticated/university/training/$sessionId'
      path: '/university/training/$sessionId'
      fullPath: '/university/training/$sessionId'
      preLoaderRoute: typeof AuthenticatedUniversityTrainingSessionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/skills/$skillId': {
      id: '/_authenticated/university/skills/$skillId'
      path: '/university/skills/$skillId'
      fullPath: '/university/skills/$skillId'
      preLoaderRoute: typeof AuthenticatedUniversitySkillsSkillIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/marketplace/$skillId': {
      id: '/_authenticated/university/marketplace/$skillId'
      path: '/university/marketplace/$skillId'
      fullPath: '/university/marketplace/$skillId'
      preLoaderRoute: typeof AuthenticatedUniversityMarketplaceSkillIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/ab-tests/new': {
      id: '/_authenticated/university/ab-tests/new'
      path: '/university/ab-tests/new'
      fullPath: '/university/ab-tests/new'
      preLoaderRoute: typeof AuthenticatedUniversityAbTestsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/university/ab-tests/$testId': {
      id: '/_authenticated/university/ab-tests/$testId'
      path: '/university/ab-tests/$testId'
      fullPath: '/university/ab-tests/$testId'
      preLoaderRoute: typeof AuthenticatedUniversityAbTestsTestIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/architect/run/$runId': {
      id: '/_authenticated/architect/run/$runId'
      path: '/architect/run/$runId'
      fullPath: '/architect/run/$runId'
      preLoaderRoute: typeof AuthenticatedArchitectRunRunIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/board/$boardId/card/$cardId': {
      id: '/_authenticated/board/$boardId/card/$cardId'
      path: '/card/$cardId'
      fullPath: '/board/$boardId/card/$cardId'
      preLoaderRoute: typeof AuthenticatedBoardBoardIdCardCardIdRouteImport
      parentRoute: typeof AuthenticatedBoardBoardIdRoute
    }
  }
}

interface AuthenticatedFilesRouteChildren {
  AuthenticatedFilesSplatRoute: typeof AuthenticatedFilesSplatRoute
}

const AuthenticatedFilesRouteChildren: AuthenticatedFilesRouteChildren = {
  AuthenticatedFilesSplatRoute: AuthenticatedFilesSplatRoute,
}

const AuthenticatedFilesRouteWithChildren =
  AuthenticatedFilesRoute._addFileChildren(AuthenticatedFilesRouteChildren)

interface AuthenticatedBoardBoardIdRouteChildren {
  AuthenticatedBoardBoardIdCardCardIdRoute: typeof AuthenticatedBoardBoardIdCardCardIdRoute
}

const AuthenticatedBoardBoardIdRouteChildren: AuthenticatedBoardBoardIdRouteChildren =
  {
    AuthenticatedBoardBoardIdCardCardIdRoute:
      AuthenticatedBoardBoardIdCardCardIdRoute,
  }

const AuthenticatedBoardBoardIdRouteWithChildren =
  AuthenticatedBoardBoardIdRoute._addFileChildren(
    AuthenticatedBoardBoardIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedBoardsRoute: typeof AuthenticatedBoardsRoute
  AuthenticatedFilesRoute: typeof AuthenticatedFilesRouteWithChildren
  AuthenticatedMissionRoute: typeof AuthenticatedMissionRoute
  AuthenticatedArchitectDispatchRoute: typeof AuthenticatedArchitectDispatchRoute
  AuthenticatedBoardBoardIdRoute: typeof AuthenticatedBoardBoardIdRouteWithChildren
  AuthenticatedConstitutionEditRoute: typeof AuthenticatedConstitutionEditRoute
  AuthenticatedConstitutionProposalsRoute: typeof AuthenticatedConstitutionProposalsRoute
  AuthenticatedDepartmentsDeptKeyRoute: typeof AuthenticatedDepartmentsDeptKeyRoute
  AuthenticatedGoalsGoalIdRoute: typeof AuthenticatedGoalsGoalIdRoute
  AuthenticatedProjectProjectIdRoute: typeof AuthenticatedProjectProjectIdRoute
  AuthenticatedSettingsMembersRoute: typeof AuthenticatedSettingsMembersRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsTelegramRoute: typeof AuthenticatedSettingsTelegramRoute
  AuthenticatedSettingsWorkspaceRoute: typeof AuthenticatedSettingsWorkspaceRoute
  AuthenticatedUniversityPatternsRoute: typeof AuthenticatedUniversityPatternsRoute
  AuthenticatedArchitectIndexRoute: typeof AuthenticatedArchitectIndexRoute
  AuthenticatedConstitutionIndexRoute: typeof AuthenticatedConstitutionIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDepartmentsIndexRoute: typeof AuthenticatedDepartmentsIndexRoute
  AuthenticatedGoalsIndexRoute: typeof AuthenticatedGoalsIndexRoute
  AuthenticatedPrinciplesIndexRoute: typeof AuthenticatedPrinciplesIndexRoute
  AuthenticatedStrategyIndexRoute: typeof AuthenticatedStrategyIndexRoute
  AuthenticatedUniversityIndexRoute: typeof AuthenticatedUniversityIndexRoute
  AuthenticatedArchitectRunRunIdRoute: typeof AuthenticatedArchitectRunRunIdRoute
  AuthenticatedUniversityAbTestsTestIdRoute: typeof AuthenticatedUniversityAbTestsTestIdRoute
  AuthenticatedUniversityAbTestsNewRoute: typeof AuthenticatedUniversityAbTestsNewRoute
  AuthenticatedUniversityMarketplaceSkillIdRoute: typeof AuthenticatedUniversityMarketplaceSkillIdRoute
  AuthenticatedUniversitySkillsSkillIdRoute: typeof AuthenticatedUniversitySkillsSkillIdRoute
  AuthenticatedUniversityTrainingSessionIdRoute: typeof AuthenticatedUniversityTrainingSessionIdRoute
  AuthenticatedUniversityTunersTunerIdRoute: typeof AuthenticatedUniversityTunersTunerIdRoute
  AuthenticatedUniversityAbTestsIndexRoute: typeof AuthenticatedUniversityAbTestsIndexRoute
  AuthenticatedUniversityMarketplaceIndexRoute: typeof AuthenticatedUniversityMarketplaceIndexRoute
  AuthenticatedUniversitySkillsIndexRoute: typeof AuthenticatedUniversitySkillsIndexRoute
  AuthenticatedUniversityTrainingIndexRoute: typeof AuthenticatedUniversityTrainingIndexRoute
  AuthenticatedUniversityTunersIndexRoute: typeof AuthenticatedUniversityTunersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBoardsRoute: AuthenticatedBoardsRoute,
  AuthenticatedFilesRoute: AuthenticatedFilesRouteWithChildren,
  AuthenticatedMissionRoute: AuthenticatedMissionRoute,
  AuthenticatedArchitectDispatchRoute: AuthenticatedArchitectDispatchRoute,
  AuthenticatedBoardBoardIdRoute: AuthenticatedBoardBoardIdRouteWithChildren,
  AuthenticatedConstitutionEditRoute: AuthenticatedConstitutionEditRoute,
  AuthenticatedConstitutionProposalsRoute:
    AuthenticatedConstitutionProposalsRoute,
  AuthenticatedDepartmentsDeptKeyRoute: AuthenticatedDepartmentsDeptKeyRoute,
  AuthenticatedGoalsGoalIdRoute: AuthenticatedGoalsGoalIdRoute,
  AuthenticatedProjectProjectIdRoute: AuthenticatedProjectProjectIdRoute,
  AuthenticatedSettingsMembersRoute: AuthenticatedSettingsMembersRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsTelegramRoute: AuthenticatedSettingsTelegramRoute,
  AuthenticatedSettingsWorkspaceRoute: AuthenticatedSettingsWorkspaceRoute,
  AuthenticatedUniversityPatternsRoute: AuthenticatedUniversityPatternsRoute,
  AuthenticatedArchitectIndexRoute: AuthenticatedArchitectIndexRoute,
  AuthenticatedConstitutionIndexRoute: AuthenticatedConstitutionIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedDepartmentsIndexRoute: AuthenticatedDepartmentsIndexRoute,
  AuthenticatedGoalsIndexRoute: AuthenticatedGoalsIndexRoute,
  AuthenticatedPrinciplesIndexRoute: AuthenticatedPrinciplesIndexRoute,
  AuthenticatedStrategyIndexRoute: AuthenticatedStrategyIndexRoute,
  AuthenticatedUniversityIndexRoute: AuthenticatedUniversityIndexRoute,
  AuthenticatedArchitectRunRunIdRoute: AuthenticatedArchitectRunRunIdRoute,
  AuthenticatedUniversityAbTestsTestIdRoute:
    AuthenticatedUniversityAbTestsTestIdRoute,
  AuthenticatedUniversityAbTestsNewRoute:
    AuthenticatedUniversityAbTestsNewRoute,
  AuthenticatedUniversityMarketplaceSkillIdRoute:
    AuthenticatedUniversityMarketplaceSkillIdRoute,
  AuthenticatedUniversitySkillsSkillIdRoute:
    AuthenticatedUniversitySkillsSkillIdRoute,
  AuthenticatedUniversityTrainingSessionIdRoute:
    AuthenticatedUniversityTrainingSessionIdRoute,
  AuthenticatedUniversityTunersTunerIdRoute:
    AuthenticatedUniversityTunersTunerIdRoute,
  AuthenticatedUniversityAbTestsIndexRoute:
    AuthenticatedUniversityAbTestsIndexRoute,
  AuthenticatedUniversityMarketplaceIndexRoute:
    AuthenticatedUniversityMarketplaceIndexRoute,
  AuthenticatedUniversitySkillsIndexRoute:
    AuthenticatedUniversitySkillsIndexRoute,
  AuthenticatedUniversityTrainingIndexRoute:
    AuthenticatedUniversityTrainingIndexRoute,
  AuthenticatedUniversityTunersIndexRoute:
    AuthenticatedUniversityTunersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
